import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { downloadBlob } from '../../services/CommonService';
import './style.css';
import { ic_broken_image } from '../../constants/Images';


const baseUrl = (eventName, imagefileName) => (`https://kmsmediasvcstorage.blob.core.windows.net/gallery/thumbnails/${eventName}/${imagefileName}`);

const GalleryImage = (props) => {
  const [url, setUrl] = useState('');

  const getImageUrl = async () => {
    const imagesUrl = await downloadBlob(baseUrl(props.eventName, props.imagefileName))
    setUrl(imagesUrl)

  }



  useEffect(() => {

    getImageUrl()


  }, [])




  return (
    <img style={{ width: '150px', cursor: 'pointer' }} src={url} alt={'Loading'}
      onError={({ currentTarget }) => {
        currentTarget.onerror = null; // prevents looping
        currentTarget.src = ic_broken_image;
      }} />

  )
}



export default GalleryImage
GalleryImage.propTypes = {
  eventName: PropTypes.string,
  imagefileName: PropTypes.string


}
